import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react'
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import { Typography } from '@mui/material';
import CustomPagination from '../../shared/utils/CustomPagination';
import { formatDateToDDMMYYYY } from '../../shared/formatter';
import { useApartmentAccountHistory } from '../../assets/api/useApartmentApi';

const AccountHistoryTable = ({ id }) => {
    const { data: ApartmentAccountHistory, isLoading } = useApartmentAccountHistory({ apartment_id: id })
    const accountRow = ApartmentAccountHistory?.account_history?.map((item, index) => ({
        id: item?.id || index + 1,
        sr_no: index + 1,
        ...item
    })) || []
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const AccountRowColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "contact_person_name",
            headerName: "Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },

        {
            field: "assigned_at",
            headerName: "Assigned At",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{formatDateToDDMMYYYY(params.value)}</Typography>,
        },
        {
            field: "unassigned_at",
            headerName: "Unassigned At",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{formatDateToDDMMYYYY(params.value)}</Typography>,
        },
        {
            field: "remarks",
            headerName: "Remarks",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "designation",
            headerName: "Designation",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
    ]
    return (
        <>

            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={accountRow}
                    columns={AccountRowColumns}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={accountRow?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}
        </>
    )
}

export default AccountHistoryTable